export default function AboutSection() {
  return (
    <section className="w-full py-20 md:py-28 px-4 md:px-6" style={{ backgroundColor: 'oklch(var(--background-100))' }}>
      <div className="max-w-5xl mx-auto">
        <div className="mb-4">
          <span
            className="text-xs md:text-sm font-medium tracking-widest uppercase"
            style={{ fontFamily: 'var(--font-label)', color: 'oklch(var(--foreground-500))' }}
          >
            About
          </span>
        </div>

        <div className="flex flex-col lg:flex-row gap-10 lg:gap-20">
          <div className="lg:w-2/3">
            <p
              className="text-lg md:text-xl lg:text-2xl leading-relaxed lg:leading-relaxed"
              style={{ color: 'oklch(var(--foreground-700))' }}
            >
              Apade Solutions OU is a professional engineering team focused on designing and developing modern digital software solutions for the iOS platform and related technologies. We build scalable, maintainable, and high-performance systems with a strong focus on usability, stability, and long-term technical quality.
            </p>
            <p
              className="mt-6 text-sm md:text-base leading-relaxed"
              style={{ color: 'oklch(var(--foreground-500))' }}
            >
              Our team follows modern software engineering practices, including clean architecture, performance optimization, and user-centered design. We emphasize continuous innovation, improvement of development workflows, and adoption of up-to-date engineering standards to deliver reliable and future-ready IT solutions. We actively explore new technologies and evolve our internal processes to maintain high technical excellence.
            </p>
          </div>

          <div className="lg:w-1/3">
            <div className="grid grid-cols-2 gap-6 md:gap-8">
              <div>
                <div
                  className="text-3xl md:text-4xl lg:text-5xl font-heading font-semibold"
                  style={{ color: 'oklch(var(--primary-500))' }}
                >
                  100<span style={{ fontSize: '0.6em', verticalAlign: 'super' }}>%</span>
                </div>
                <p
                  className="mt-2 text-xs md:text-sm"
                  style={{ color: 'oklch(var(--foreground-500))' }}
                >
                  iOS platform focus
                </p>
              </div>
              <div>
                <div
                  className="text-3xl md:text-4xl lg:text-5xl font-heading font-semibold"
                  style={{ color: 'oklch(var(--accent-500))' }}
                >
                  24<span style={{ fontSize: '0.6em', verticalAlign: 'super' }}>/7</span>
                </div>
                <p
                  className="mt-2 text-xs md:text-sm"
                  style={{ color: 'oklch(var(--foreground-500))' }}
                >
                  Engineering excellence
                </p>
              </div>
              <div>
                <div
                  className="text-3xl md:text-4xl lg:text-5xl font-heading font-semibold"
                  style={{ color: 'oklch(var(--secondary-500))' }}
                >
                  0
                </div>
                <p
                  className="mt-2 text-xs md:text-sm"
                  style={{ color: 'oklch(var(--foreground-500))' }}
                >
                  Compromises on quality
                </p>
              </div>
              <div>
                <div
                  className="text-3xl md:text-4xl lg:text-5xl font-heading font-semibold"
                  style={{ color: 'oklch(var(--primary-400))' }}
                >
                  ∞
                </div>
                <p
                  className="mt-2 text-xs md:text-sm"
                  style={{ color: 'oklch(var(--foreground-500))' }}
                >
                  Continuous innovation
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}